import { render, staticRenderFns } from "./UserAsk.vue?vue&type=template&id=053d7053&scoped=true&"
import script from "./UserAsk.vue?vue&type=script&lang=js&"
export * from "./UserAsk.vue?vue&type=script&lang=js&"
import style0 from "./UserAsk.vue?vue&type=style&index=0&id=053d7053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d7053",
  null
  
)

export default component.exports